import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { CurrencyRepository } from '@/store/currency-state/currency-state.repository';

interface IgetCurrencyUpdateDrawerObjectProps {
  store?: CurrencyRepository;
  formObject?: DynamicForm;
  action?: () => void;
  toggleVisibility?: () => void;
}

export const getCurrencyUpdateDrawerObject = ({ store, formObject, toggleVisibility, action }: IgetCurrencyUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.currency.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.currency.update.update',
        onClick: () => action?.(),
        disabled: store?.getObservable<boolean>('isEqual'),
      },
      {
        label: 'settings.currency.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
